module.exports = __webpack_public_path__ + "img/15.704da621.jpg";